export default __webpack_public_path__ + "static/dirty-pan-2394d9ee540d2a56231e52b72b9646f4.webp";